export default __webpack_public_path__ + "5d737c8b1f70932ded7f3fdc7bb92735.svg";